import { takeLatest } from 'redux-saga/effects';
import { createBlockWorker, fetchPagesOfBlockWorker } from './blockWorkerSaga';
import { CREATE_BLOCK_REQUEST, FETCH_BLOCK_LIST_REQUEST } from '../../redux/modules/block/block-actions';


export function* fetchPagesOfBlockWatcher() {
    yield takeLatest(FETCH_BLOCK_LIST_REQUEST, fetchPagesOfBlockWorker);
}

export function* createBlockWatcher() {
    yield takeLatest(CREATE_BLOCK_REQUEST, createBlockWorker);
}
